import { render, staticRenderFns } from "./ProductSpesification.vue?vue&type=template&id=3a96414a&scoped=true"
import script from "./ProductSpesification.vue?vue&type=script&lang=js"
export * from "./ProductSpesification.vue?vue&type=script&lang=js"
import style0 from "./ProductSpesification.vue?vue&type=style&index=0&id=3a96414a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96414a",
  null
  
)

export default component.exports